<!-- src/views/pages/superadmin/purchase/purchase-table.vue -->
<script setup>
import { computed } from "vue";
import { usePurchaseTransactionStore } from "@/stores/purchaseTransactionStore";

const store = usePurchaseTransactionStore();
const emit = defineEmits(["view"]);

const columns = [
  { sorter: false },
  {
    title: "Invoice ID",
    dataIndex: "invoice_no",
    key: "invoice_no",
    sorter: true,
  },
  {
    title: "Customer",
    dataIndex: "company_name",
    key: "company_name",
    sorter: true,
  },
  {
    title: "Email",
    dataIndex: "company_email",
    sorter: true,
  },
  {
    title: "Created Date",
    dataIndex: "created_date",
    sorter: true,
  },
  {
    title: "Plan",
    dataIndex: "plan_name",
    sorter: true,
  },
  {
    title: "Amount",
    dataIndex: "amount_display",
    sorter: true,
  },
  {
    title: "Payment Method",
    dataIndex: "payment_method",
    sorter: true,
  },
  {
    title: "Status",
    dataIndex: "payment_status",
    key: "payment_status",
    sorter: true,
  },
  {
    title: "",
    key: "action",
    sorter: false,
  },
];

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

const dataSource = computed(() => store.items);
</script>

<template>
  <a-table
    class="table datatable thead-light"
    :columns="columns"
    :data-source="dataSource"
    :row-selection="rowSelection"
    :loading="store.loading"
    row-key="id"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'invoice_no'">
        <a href="javascript:void(0);" class="link-default">
          {{ record.invoice_no }}
        </a>
      </template>

      <template v-else-if="column.key === 'company_name'">
        <div class="d-flex align-items-center file-name-icon">
          <div class="avatar avatar-md border rounded-circle d-flex align-items-center justify-content-center">
            {{ record.company_name?.charAt(0) ?? "C" }}
          </div>
          <div class="ms-2">
            <h6 class="fw-medium mb-0">
              <a href="javascript:void(0);">
                {{ record.company_name }}
              </a>
            </h6>
            <small class="text-muted">{{ record.company_email }}</small>
          </div>
        </div>
      </template>

      <template v-else-if="column.key === 'payment_status'">
        <span
          :class="[
            'badge',
            record.payment_status === 'paid'
              ? 'badge-success'
              : record.payment_status === 'refunded'
              ? 'badge-danger'
              : record.payment_status === 'failed'
              ? 'badge-danger'
              : record.payment_status === 'pending'
              ? 'badge-warning'
              : record.payment_status === 'unpaid'
              ? 'badge-warning'
              : 'badge-warning',
            'd-flex',
            'align-items-center',
            'badge-xs',
          ]"
        >
          <i class="ti ti-point-filled me-1"></i>
          {{
            record.payment_status.charAt(0).toUpperCase() +
            record.payment_status.slice(1)
          }}
        </span>
      </template>

      <template v-else-if="column.dataIndex === 'plan_name'">
        <span>{{ record.plan_name || "-" }}</span>
      </template>

      <template v-else-if="column.key === 'action'">
        <div class="action-icon d-inline-flex">
          <a
            href="javascript:void(0);"
            class="me-2"
            @click="emit('view', record)"
            data-bs-toggle="modal"
            data-bs-target="#view_invoice"
          >
            <i class="ti ti-file-invoice"></i>
          </a>
          <a
            href="javascript:void(0);"
            @click="store.removeTransaction(record.id)"
          >
            <i class="ti ti-trash"></i>
          </a>
        </div>
      </template>
    </template>
  </a-table>
</template>
